import React from "react";
import ReactECharts from "echarts-for-react";

const BarChart = ({ data }) => {
  const category = data?.map((item) => item.key ?? "Unknown") || [];
  const values = data?.map((item) => item.doc_count ?? 0) || [];

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
    },
    grid: {
      left: "3%",
      right: "3%",
      bottom: "2%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: category, // ✅ correct usage
      axisLabel: {
        rotate: 30,
        fontSize: 10,
        interval: 0,
      },
      axisTick: {
        alignWithLabel: true,
      },
    },
    yAxis: {
      type: "value", // ✅ fixed (no `data` here!)
      splitLine: { show: false },
    },
    series: [
      {
        name: "No Parts",
        type: "bar",
        barWidth: "30%",
        data: values,
        itemStyle: {
          // color: "#5DADE2",
          color: "#5DADE2",

          borderRadius: [4, 4, 0, 0],
        },
      },
    ],
  };

  const chartWidth = Math.max(category.length * 60, 400);

  return (
    <div className="overflow-x-auto border rounded shadow-sm p-2 bg-white">
      <div style={{ minWidth: `${chartWidth}px` }}>
        <ReactECharts option={option} style={{ height: "290px", width: "100%" }} />
      </div>
    </div>
  );
};

export default BarChart;
